export const getActionSearchText = (setting) => {
  if (!setting) return '';

  const customData = setting.customData || setting.data || {};
  let customDataText = '';
  try {
    customDataText = JSON.stringify(customData);
  } catch (_error) {
    customDataText = '';
  }

  return [
    setting.id,
    setting.name,
    setting.type,
    setting.scope,
    customData?.tag,
    customData?.name,
    customData?.description,
    customData?.variable,
    customData?.target_tag,
    customData?.targetTag,
    customDataText,
  ]
    .filter((value) => value !== null && value !== undefined)
    .map((value) => String(value).toLowerCase())
    .join(' ');
};

export const findActionSearchMatchIds = (settings, query) => {
  const normalizedQuery = String(query || '').trim().toLowerCase();
  if (!normalizedQuery) return new Set();

  return new Set(
    (settings || [])
      .filter((setting) => getActionSearchText(setting).includes(normalizedQuery))
      .map((setting) => String(setting.id))
  );
};
